import { AriValues, DailySet, Promo, Row } from "./types";
import { addDays, eachDayOfInterval, format, isWithinInterval, subDays } from "date-fns";

function mapToInterval(dailySet: DailySet[]) {
  if (Array.isArray(dailySet)) {
    return dailySet.map((it: DailySet) => ({
      range: {
        start: new Date(it.startDate),
        end: new Date(it.endDate),
      },
      value: it.value,
    }));
  }
}

export function generateRows({
  ariValues,
  selectedInventoryTicker,
  sortedPromos,
  checkIn,
  checkOut,
  initial,
  currentGhostDate,
}: {
  selectedInventoryTicker: string;
  sortedPromos: Promo[];
  ariValues: AriValues | undefined;
  checkIn: string;
  checkOut: string;
  initial?: boolean;
  currentGhostDate?: Date;
}) {
  const items: Row[] = [];
  if (ariValues && checkIn && checkOut && selectedInventoryTicker) {
    const mainRange = {
      start: new Date(checkIn),
      end: new Date(subDays(new Date(checkOut), 1)),
    };

    const dailyAriPrice = ariValues[selectedInventoryTicker].rate?.dailySet
      .flatMap(range => {
        return eachDayOfInterval({
          start: new Date(range.startDate),
          end: new Date(range.endDate),
        }).map(date => ({ [format(date, "yyyy-MM-dd")]: Number(Number(range.value).toFixed(2)) }));
      })
      .reduce((accum, curr) => ({ ...accum, ...curr }), {});

    if (initial) {
      const days = eachDayOfInterval({
        start: subDays(new Date(checkIn), 3),
        end: addDays(new Date(checkOut), 2),
      }).map(day => format(day, "yyyy-MM-dd"));
      days.forEach((day, index) => {
        const ariPrice =
          dailyAriPrice[day] ||
          (dailyAriPrice[day] === undefined || dailyAriPrice[day] === null ? "-" : 0);
        items.push({
          date: day,
          ariPrice,
          promos: sortedPromos,
          appliedPrice: undefined,
        });
      });
    } else if (!initial && currentGhostDate) {
      const ariPrice =
        dailyAriPrice[format(currentGhostDate, "yyyy-MM-dd")] ||
        (dailyAriPrice[format(currentGhostDate, "yyyy-MM-dd")] === undefined ||
        dailyAriPrice[format(currentGhostDate, "yyyy-MM-dd")] === null
          ? "-"
          : 0);
      items.push({
        date: format(currentGhostDate, "yyyy-MM-dd"),
        ariPrice,
        promos: sortedPromos,
        appliedPrice: undefined,
      });
    }

    const availabilityRange = mapToInterval(
      ariValues[selectedInventoryTicker] &&
        ariValues[selectedInventoryTicker].availability?.dailySet
    );
    const closedRange = mapToInterval(
      ariValues[selectedInventoryTicker] && ariValues[selectedInventoryTicker].closed?.dailySet
    );
    const maxNoticeRange = mapToInterval(
      ariValues[selectedInventoryTicker] && ariValues[selectedInventoryTicker].maxNotice?.dailySet
    );
    const minNoticeRange = mapToInterval(
      ariValues[selectedInventoryTicker] && ariValues[selectedInventoryTicker].minNotice?.dailySet
    );
    const minStayRange = mapToInterval(
      ariValues[selectedInventoryTicker] && ariValues[selectedInventoryTicker].minStay?.dailySet
    );
    const maxStayRange = mapToInterval(
      ariValues[selectedInventoryTicker] && ariValues[selectedInventoryTicker].maxStay?.dailySet
    );
    items.map(item => {
      const availability =
        availabilityRange &&
        availabilityRange.find(it => isWithinInterval(new Date(item.date), it.range))?.value;
      const closed =
        closedRange &&
        closedRange.find(it => isWithinInterval(new Date(item.date), it.range))?.value;
      const maxNotice =
        maxNoticeRange &&
        maxNoticeRange.find(it => isWithinInterval(new Date(item.date), it.range))?.value;
      const minNotice =
        minNoticeRange &&
        minNoticeRange.find(it => isWithinInterval(new Date(item.date), it.range))?.value;
      const minStay =
        minStayRange &&
        minStayRange.find(it => isWithinInterval(new Date(item.date), it.range))?.value;
      const maxStay =
        maxStayRange &&
        maxStayRange.find(it => isWithinInterval(new Date(item.date), it.range))?.value;
      item.restrictions = {};

      if (availability) {
        item.restrictions.availability = Number(availability);
      }
      if (closed) {
        item.restrictions.closed = Boolean(closed);
      }
      if (maxNotice) {
        item.restrictions.maxNotice = Number(maxNotice);
      }
      if (minNotice) {
        item.restrictions.minNotice = Number(minNotice);
      }
      if (minStay) {
        item.restrictions.minStay = Number(minStay);
      }
      if (maxStay) {
        item.restrictions.maxStay = Number(maxStay);
      }

      if (isWithinInterval(new Date(item.date), mainRange)) {
        item.appliedPrice = 0;
      }

      return item;
    });
  }
  return items;
}
